import { useContext, useEffect, useRef, useState } from "react";
import { MdDeleteForever, MdPause, MdPlayArrow, MdCall } from "react-icons/md";
import { api, themeColor } from "../../../..";
import { intToTime } from "../../../../Components/Global";
import { useTranslation } from 'react-i18next';
import { ShowConfirmPopUp } from "../../../../Components/Popup/Popup";
import { toast } from "react-toastify";
import { PusherContext } from "../../../../PusherContextProvider";

const Agent = (props: any) => {
	const [ member, setMember ] = useState(props.member);
	const [ secondsInCall, setSecondsInCall ] = useState(0);
	const [ lastCallCounter, setLastCallCounter ] = useState(parseInt(props.member.last_call ?? 0));
	const lastCallCounterRef = useRef<number>(parseInt(props.member.last_call ?? 0));
	const inCallCounterRef = useRef<number>(parseInt(props.member.remote_seconds ?? 0));
	const statusRef = useRef<number>(0);
	const pusher = useContext(PusherContext)
	const { t } = useTranslation();

	const handleCounter = (intervalId: any, member: any, lastMember: any) => {
		if(intervalId) {
			if(lastMember.remote_name !== null && member.remote_name === null) {
				clearInterval(intervalId)
				inCallCounterRef.current = 0
				setSecondsInCall(0);

				return 0
			}
		} else if(lastMember.remote_name === null && (member.remote_seconds || member.remote_name)) {
			inCallCounterRef.current = parseInt(member.remote_seconds ?? 0);
			setSecondsInCall(inCallCounterRef.current)

			return window.setInterval(() => {
				setSecondsInCall(inCallCounterRef.current++)
			}, 1000);
		}

		return intervalId
	}

	const handleLastCallSeconds = (intervalId: any, member: any, lastMember: any) => {
		// After the call is finished
		const tookACall = lastMember.calls_taken !== member.calls_taken

		if(
			// Only if we started a call
			(
				statusRef.current === 1 &&
				member.remote_name !== null &&
				lastMember.remote_name !== member.remote_name
			)
			||
			// or went from in a call to not in a call
			(
				tookACall &&
				lastMember.remote_name !== null &&
				member.remote_name === null
			)
		) {
			lastCallCounterRef.current = 0;
		}

		// Don't count idle when we're in a call
		/*
		if(statusRef.current === 1 && lastMember.remote_name === null && member.remote_name !== null) {
			lastCallCounterRef.current = -1;
			setLastCallCounter(0)

			return intervalId
		}
		*/

		if(!intervalId && member?.last_call != "0" && member.remote_name === null) {
			return window.setInterval(() => {
				if(lastCallCounterRef.current !== -1) {
					setLastCallCounter(lastCallCounterRef.current++)
				}
			}, 1000);
		}

		return intervalId
	}

	useEffect(() => {
		let intervalInCallId = 0;
		let intervalLastCallId = 0;
		let messageListenerId = 0;

		if(api.accessToken) {
			let lastMember = member

			// For some reason some values are empty string instead of null
			const replaceStringWithNull = [
				'remote_name',
				'remote_number',
				'call_guid'
			];

			replaceStringWithNull.forEach((i: string) => {
				if(lastMember[i] === '') {
					lastMember[i] = null
				}
			})

			if (pusher) {
				messageListenerId = pusher.pushOnMessageListener('Queue', (q: any) => {
					if(q.queue.id == member.pbx_queue_id) {
						const m = q.members.find((m: any) => m.id == member.id)

						if(m) {
							setMember(m)
							intervalInCallId = handleCounter(intervalInCallId, m, lastMember);
							intervalLastCallId = handleLastCallSeconds(intervalLastCallId, m, lastMember)
							lastMember = m
						}
					}
				})

				pusher.pushOnMessageListener('UserStatus', (event: any) => {
					if(props.member.pbx_user_id == event.pbx_user_id) {
						statusRef.current = parseInt(event.status);
					}
				})
			}

			if(member.last_call !== '0' ) {
				intervalInCallId = handleCounter(intervalInCallId, member, member)
				intervalLastCallId = handleLastCallSeconds(intervalLastCallId, member, member)
			}
		}

		return () => {
			clearInterval(intervalInCallId)
			clearInterval(intervalLastCallId)

			if (pusher) {
				pusher.removeOnPushMessageListener('Queue', messageListenerId)
			}
		}
		// eslint-disable-next-line
	}, [])

	const toggleAgent = () => {
		ShowConfirmPopUp(t('are_you_sure'), (value:any) => {
			if (value) {
				api.calls.queue.members.update(member.pbx_queue_id, member.id, {paused: member.paused == "1" ? "0" : "1"})
				.then((r: any) => {
					if(r.status === 200) {
						toast.success(t('agent_status_successfully_changed'));
					} else {
						toast.error(t('something_went_wrong_please_try_again'));
					}
				});
			}
		}, themeColor);
	}

	const removeAgent = () => {
		ShowConfirmPopUp(t('are_you_sure'), (value:any) => {
			if (value) {
				api.calls.queue.members.delete(member.pbx_queue_id, member.id)
				.then((r: any) => {
					if(r.status === 200) {
						toast.success(t('agent_successfully_removed'));
					} else {
						toast.error(t('something_went_wrong_please_try_again'));
					}
				});
			}
		}, themeColor);
	}

	return <tr className="agent">
		<td>
			{
				member.paused == "1" ?
					<span className="gray">{member.membername}</span>
				:
					member.membername
			}
		</td>
		<td>
			{
				member.calls_taken
			}
		</td>
		<td>
			{
				secondsInCall ?
					<span className="call-data">
						<MdCall className="seconds-icon" /> {`${intToTime(secondsInCall)}`}
					</span>
				:
					null
			}
		</td>
		<td>
			{
				intToTime(lastCallCounter ?? 0)
			}
		</td>
		<td>
			{
				member.paused == "1" ?
					<MdPlayArrow
						className="icon"
						title={t('pause')}
						onClick={toggleAgent}
					/>
				:
					<MdPause
						className="icon"
						title={t('play')}
						onClick={toggleAgent}
					/>
			}
		</td>
		<td>
			<MdDeleteForever
				className="icon"
				title={t('delete')}
				onClick={removeAgent}
			/>
		</td>
	</tr>
}

export default Agent;
